<template>
  <div id="mydetail">
    <Form :label-width="80">
      <FormItem :label="item.title" v-for="(item, index) in datas" :key="index">
        <viewer v-if="item.mark == 'pic'&&item.value != null">
          <img
            :src="item.value"
            width="28"
            height="28"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
        <span v-else>{{ item.value }}</span>
      </FormItem>
    </Form>
    <slot name="btn"></slot>
  </div>
</template>
<script>
export default {
  props: ["datas"],
  data() {
    return {
      /* datas: [
        {
          title: "订单名称",
          value: "这是我的订单",
        },
        {
          title: "订单名称",
          value: "这是我的订单",
        },
        {
          title: "订单名称",
          value: "这是我的订单",
        },
      ], */
    };
  },
};
</script>
<style lang="">
#mydetail .ivu-form-item {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Detail.vue